import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { loadAvailableGroomers } from 'actions/groomers';
import { DefaultAvatar } from 'atoms/default-avatar';
import RadioButtonCustomGroup from 'atoms/radio-button-custom-group';
import AvailableGroomerSelectLoader from 'organisms/Loaders/ReassignDrawerLoader/AvailableGroomerSelectLoader';
import { capitalizeFirstLetter, isNotEmptyArray } from 'util';

export default function AvailableGroomerSelect({
  luid,
  dateStart,
  animalType,
  selectedGroomer,
  setSelectedGroomer,
  currentGroomerUuid,
}) {
  const dispatch = useDispatch();
  const [groomers, setGroomers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const [date, time] = dateStart ? dateStart.split('T') : [];
    setIsLoading(true);
    dispatch(loadAvailableGroomers({ luid, date, time })).then(
      ({ success, data }) => {
        if (success) {
          setGroomers(
            data.data.filter(
              (groomer) => groomer.user.uuid !== currentGroomerUuid
            )
          );
        }
        setIsLoading(false);
      }
    );
  }, []);

  if (isLoading) return <AvailableGroomerSelectLoader />;

  if (!isNotEmptyArray(groomers))
    return <h3 className="f16 mb-15">No groomers available</h3>;

  const groomerOptions = groomers.map((groomer) => {
    const isGroomerAvailable = groomer?.animal?.type?.some(
      (type) => type?.id === animalType?.id
    );

    return {
      label: (
        <div className="flex-row">
          <DefaultAvatar
            avatar={groomer?.user?.links?.image?.desktop?.small}
            size="small"
          />
          <div className="flex-column ml-8">
            <p className="f13 bold">
              {`${capitalizeFirstLetter(groomer?.user?.firstName)}${
                !isGroomerAvailable ? ' (Unavailable)' : ''
              }`}
            </p>
            <p className="f11 c-primary-purple">
              {capitalizeFirstLetter(
                groomer?.animal?.type
                  ?.map((type) => `${type.value}s`)
                  .join(', ')
                  .toLowerCase()
              )}
            </p>
          </div>
        </div>
      ),
      value: groomer?.user?.uuid,
      disabled: !isGroomerAvailable,
    };
  });

  return (
    <RadioButtonCustomGroup
      options={groomerOptions}
      value={selectedGroomer}
      setValue={setSelectedGroomer}
    />
  );
}
